{
  const email = document.querySelector('[data-email]');   
  const message = document.querySelector('[data-message]');  
  const sendButton = document.querySelector('[data-send]');   
  if (email && sendButton) {
	sendButton.onsubmit = function(event) { 
	  event.preventDefault();
	  const state = {
        name: '',
        email: '',
		url: '',
		message: '',
		from: 'global.omnio.site'
      }
	  var regex = /^[-0-9a-zA-Z_.]+@[-0-9a-z_^\.]+\.[a-z]{2,6}$/;
      var isValid = true	  
	  if (!regex.exec(email.value)) {
	    email.placeholder = 'Invalid e-mail format';
		email.value = '';
		email.classList.add('partners-info__input-error');
		isValid = false	
      } 
	  if (!message.value) {
	    message.placeholder = 'The field must be filled!';
		message.value = '';
		message.classList.add('partners-info__input-error');
		isValid = false
      }
	  if (isValid) {
		  const inputs = document.querySelectorAll('[data-input]');
		  [...inputs].forEach((input) => {	
            state[input.name] = input.value;
			input.value = '';
          });		  
	    fetch('/sendnewrequest?params=' + JSON.stringify(state), {
          method: 'GET',
        })
        .then(() => {
		  document.querySelector('[data-send-block]').classList.add('partners-info--hidden');
		  document.querySelector('[data-success-block]').classList.add('partners-info--visible');
        }).catch((e) => {
		  document.querySelector('[data-send-block]').classList.add('partners-info--hidden');
		  document.querySelector('[data-error-block]').classList.add('partners-info--visible');
        }) 		  
	  }
	}
	email.onclick = function() { 
	  email.classList.remove('partners-info__input-error');
	  email.placeholder = 'Your E-mail*';
    }
	message.onclick = function() { 
	  message.classList.remove('partners-info__input-error');
	  message.placeholder = 'Text*';
    }	
  }  
}
